"use client";

import { useTranslations } from "next-intl";

import { AudioGenerationWidget } from "../audio/AudioGenerationWidget";
import type { AudioGenerationWidgetProps, GeneratedSoundItem } from "../audio/AudioGenerationWidget";
import { EventName } from "@mw/shared/analyticsEventNames";

type MusicGenerationWidgetProps = Omit<AudioGenerationWidgetProps, "showLoopToggle" | "labels" | "eventNames">;

function MusicGenerationWidget(props: MusicGenerationWidgetProps) {
  const t = useTranslations("ClientKeys.MusicGenerationWidget");
  return (
    <AudioGenerationWidget
      {...props}
      showLoopToggle={false}
      eventNames={{
        signUpCtaClicked: EventName.mw_music_category_generation_signup_cta_clicked,
        suggestionPillClicked: EventName.mw_music_category_generation_suggestion_clicked,
      }}
      labels={{
        pillText: t("create_your_own_music"),
        headerText: t("generate_music"),
        placeholder: t("describe_music"),
      }}
    />
  );
}

MusicGenerationWidget.displayName = "MusicGenerationWidget";

export { MusicGenerationWidget };
export type { MusicGenerationWidgetProps, GeneratedSoundItem };
